import { gql } from '@apollo/client'

export const CHAT_CUSTOMER_FRAGMENT = gql`
  fragment ChatCustomer on Customer {
    id
    firebaseId
    firebaseToken
    isAnonymous
    chats {
      id
      locationId
    }
  }
`
